<template lang="pug">
  .order-data-container(@click="expand = !expand" :class="{ 'is-fraud-blocked': isFraudBlocked }")
    .order-data
      // .order-index {{ index + 1 }}
      .menu-icon-order.relative(@click.stop="" style="order: -1;")
        img(:src="require('@/assets/menu.svg')" alt="menu" @click="showMenu")
        transition(name="opacity-bottom")
          shMenuOrder(v-if="showedMenu" @copyDataSky="copyDataSky" @copyDataExcel="copyDataLocal" @copyDataUrl="copyOrder" @cloneOrder="cloneOrder" @openStaffRefund="openStaffRefundFromMenu" @sendStatusNotification="sendOrderStatusNotification" @openNotificationHistory="openNotificationHistoryModal" :index="indexMenu")

      .order-number(v-if="fieldsOrder.order.show" :style="`order: ${fieldsOrder.order.order};`")
        span.material-symbols-outlined(:class="`color-${data.brand}`") shopping_cart
        span.tag(:class="`bg-${data.brand}`") {{ data.order }}

      .divider-order(v-if="fieldsOrder.order.divider" :style="`order: ${fieldsOrder.order.order};`")

      .order-status(v-if="fieldsOrder.status.show" :style="`order: ${fieldsOrder.status.order};`")
        .tag(:style="styleStatus") {{ statusSpanish[data.status] }}

      .divider-order(v-if="fieldsOrder.status.divider" :style="`order: ${fieldsOrder.status.order};`")

      .order-method-pay(v-if="fieldsOrder.methodPay.show" :style="`order: ${fieldsOrder.methodPay.order};`")
        img(:src="`${imagePath}/methods/light/mini-${data.methodPay}.png`" :alt="data.methodPay")

      .divider-order(v-if="fieldsOrder.methodPay.divider" :style="`order: ${fieldsOrder.methodPay.order};`")

      .order-conveyor(v-if="fieldsOrder.conveyor.show" :style="`order: ${fieldsOrder.conveyor.order};`")
        img(v-if="data.conveyor !== data.brand" :src="`${imagePath}/conveyors/light/mini-${data.conveyor}.png`" :alt="data.conveyor")

      .divider-order(v-if="fieldsOrder.conveyor.divider" :style="`order: ${fieldsOrder.conveyor.order};`")

      .order-total(v-if="fieldsOrder.total.show" :style="`order: ${fieldsOrder.total.order};`") {{ money(total) }}

      .divider-order(v-if="fieldsOrder.total.divider" :style="`order: ${fieldsOrder.total.order};`")

      .order-percent-profit(v-if="fieldsOrder.percent.show" :class="colorProfit" :style="`order: ${fieldsOrder.percent.order};`")
        shTagDescription(:description="money(total - costs)")
          .tag.no-select {{ percent((total - costs) / total * 100) }}

      .divider-order(v-if="fieldsOrder.percent.divider" :style="`order: ${fieldsOrder.percent.order};`")

      .order-name.capitalize(v-if="fieldsOrder.name.show" :style="`order: ${fieldsOrder.name.order};`")
        span.gift-tape(v-if="data.isGift")
          img(:src="require('@/assets/gift.png')")
        span {{ cutValue(name(data.name)) }}

      .divider-order(v-if="fieldsOrder.name.divider" :style="`order: ${fieldsOrder.name.order};`")

      .order-location.capitalize(v-if="fieldsOrder.location.show" :style="`order: ${fieldsOrder.location.order};`")
        shTagDescription(:description="data.location + ' - ' + data.department")
          .no-select {{ cutValue(data.location) }}

      .divider-order(v-if="fieldsOrder.location.divider" :style="`order: ${fieldsOrder.location.order};`")

      .order-phone(v-if="fieldsOrder.phones.show" :style="`order: ${fieldsOrder.phones.order};`") {{ data.phones[0] }}

      .divider-order(v-if="fieldsOrder.phones.divider" :style="`order: ${fieldsOrder.phones.order};`")

      .order-reconcile(v-if="fieldsOrder.reconcile.show" :style="`order: ${fieldsOrder.reconcile.order};`") {{ data.paidWholesaler ? 'C' : 'NC' }}

      .divider-order(v-if="fieldsOrder.reconcile.divider" :style="`order: ${fieldsOrder.reconcile.order};`")

      .order-date(v-if="fieldsOrder.createdAt.show" :style="`order: ${fieldsOrder.createdAt.order};`") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

      .divider-order(v-if="fieldsOrder.createdAt.divider" :style="`order: ${fieldsOrder.createdAt.order};`")

      .order-remit(v-if="fieldsOrder.remit && fieldsOrder.remit.show" :style="`order: ${fieldsOrder.remit.order};`" @click.stop="")
        RemitDataIcon(:order="data")

      .divider-order(v-if="fieldsOrder.remit && fieldsOrder.remit.divider" :style="`order: ${fieldsOrder.remit.order};`")

      .order-fraud-count-col(v-if="fraudConfirmedCount" :style="`order: ${fraudCountFieldOrder};`")
        span.tag.order-fraud-count(:title="fraudCountTitle(fraudConfirmedCount)") {{ fraudConfirmedCount }}

    .order-actions-container(@click.stop="")
      .order-actions.relative
        .undo(v-if="data.status !== 'created'")
          img(v-if="action.previousAction" :src="require('@/assets/undo.svg')" :alt="`undo-${data.status}`" @click="undoAction" :class="{disabled: isLoading}" )
        .undo(v-else-if="data.status === 'created'")
          img(v-if="action.previousAction" :src="require('@/assets/times.svg')" :alt="`undo-${data.status}`" @click="undoAction" :class="{disabled: isLoading}" )
        .undo(v-else)
        .buttons-actions
          shActionButton(v-if="action.nextAction" :action="action.nextAction" :params="[data.order]"  :text="sendActionText" :textRunning="sendActionTextRunning" width="9rem" :textConfirmation="sendConfirmation" :disabled="isPackActionBlocked")
          SendSkipGuideToggle(v-if="canSkipGuide" v-model="skipGuide")

    transition(name="slide-fade")
      shForm.list-order(v-if="expand" ref="orderFormExpand" :dataOriginal="data" :fillData="true" @click.native.stop="")

    NotificationHistoryModal(
      :show="notificationHistoryModal.show"
      :order="data"
      @close="closeNotificationHistoryModal"
    )
</template>

<script>
import shForm from './Form'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gqlOrder from '@/graphql/order'
import gql from '@my/graphql'
import shMenuOrder from './MenuOrder'
import RemitDataIcon from '@/components/elements/remit/RemitDataIcon.vue'
import SendSkipGuideToggle from '@/components/elements/order/SendSkipGuideToggle.vue'
import NotificationHistoryModal from '@/components/pages/order/NotificationHistoryModal.vue'
import { isBlockedByFraud, fraudCountTitle } from '@/helpers/fraudReview'
import { isBlockedByProductChange, isBlockedByAddressNovelty } from '@/helpers/orderNovelty'

export default {
  name: 'Order',

  mixins: [mFilters, mForm],

  components: { shForm, shMenuOrder, RemitDataIcon, SendSkipGuideToggle, NotificationHistoryModal },

  props: {
    data: Object,
    index: Number,
    realIndex: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      animationCopy: false,
      statusSpanish: {
        created: 'Creado',
        approved: 'Aprobado',
        paid: 'Pagado',
        packed: 'Empacado',
        sent: 'Enviado',
        declined: 'Declinado',
        expired: 'Expirado'
      },
      isLoading: false,
      skipGuide: false,
      indexMenu: -1,
      notificationHistoryModal: {
        show: false
      }
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    fraudCountTitle,
    cutValue (value) {
      const maxLength = 8
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    },
    async showMenu () {
      console.log('showMenu', this.showedMenu)
      if (this.showedMenu) {
        this.hideMenu()
        return
      }

      if (this.indexMenu !== -1) {
        this.$store.commit('showMenu', this.indexMenu)
        return
      }

      this.indexMenu = await this.$store.dispatch('setMenu')
    },

    hideMenu () {
      this.$store.commit('hideMenu', this.indexMenu)
    },

    cloneOrder () {
      window.open(`https://${this.data.brand}.co?clone=${this.data.order}`)
    },

    openStaffRefundFromMenu () {
      const open = () => {
        const form = this.$refs.orderFormExpand
        if (form && typeof form.openStaffRefundModal === 'function') {
          form.openStaffRefundModal(true)
        }
      }
      if (!this.expand) {
        this.expand = true
        this.$nextTick(open)
      } else {
        open()
      }
    },

    async sendOrderStatusNotification () {
      const order = this.data && this.data.order
      if (!order) return

      const response = await gql.mutate(gqlOrder.SEND_STATUS_NOTIFICATION, { order })
      if (response) {
        modals.showMessage({ message: `Se envió la notificación de estado de la orden ${order}` })
      }
    },

    openNotificationHistoryModal () {
      this.notificationHistoryModal.show = true
    },

    closeNotificationHistoryModal () {
      this.notificationHistoryModal.show = false
    },

    copyOrder () {
      const phone = this.data.phones && this.data.phones[0] ? String(this.data.phones[0]) : ''
      const fourDigits = phone.replace(/\D/g, '').slice(-4)
      const base = `https://${this.data.brand}.co/o/${this.data.order}`
      const url = fourDigits ? `${base}?v=${fourDigits}` : base
      this.copyNavigator(url)
      modals.showMessage({ message: `La URL de la orden ${this.data.order} ha sido copiada` })
    },

    copyDataLocal () {
      let csv = ''

      const { order, address, location, department, phones, methodPay, name, brand } = this.data

      const total = this.total
      const date = new Date()
      const dateFormatted = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

      csv = `${dateFormatted}\t${order}\t${brand}\t${address}\t${location} - ${department}\t${name}\t${phones.join(', ')}\t${methodPay === 'cod' ? 'Sí' : 'No'}\t${methodPay === 'cod' ? total : 0}`

      const csvNoEnter = csv.replace(/\n/g, '')
      this.copyNavigator(csvNoEnter)

      modals.showMessage({ message: 'Se copió la orden para Excel' })
    },

    copyDataSky () {
      let csv = ''

      const { address, location, department, phones, methodPay, name, email } = this.data

      const total = this.total

      csv = `${name}\t${email}\t${phones[0]}\t${address.replace(/\t/g, '')}\t(${location} - ${department})\tconfeccion\t${parseInt(total / 2)}\t${total}\t${methodPay}`

      const csvNoEnter = csv.replace(/\n/g, '')
      this.copyNavigator(csvNoEnter)

      modals.showMessage({ message: 'Se copió la orden para Skydropx' })
    },

    copyNavigator (text) {
      try {
        this.animationCopy = true
        const type = 'text/plain'
        const blob = new Blob([text], { type })
        const data = [new window.ClipboardItem({ [type]: blob })]
        navigator.clipboard.write(data)

        setTimeout(() => { this.animationCopy = false }, 200)
      } catch (error) {
        console.log('Característica sólo soportada en Chrome')
      }
    },
    name (value) {
      if (!value) return value
      const names = value.split(' ')
      return names[0] || names[1]
    },

    async undoAction () {
      if (this.isLoading) return
      try {
        console.log('isLoading', this.isLoading)
        this.isLoading = true

        const action = this.action.previousAction
        action(this.data.order)
      } catch (error) {
        console.log(error)
      } finally {
        setTimeout(() => {
          this.isLoading = false
          console.log('isLoading', this.isLoading)
        }, 500)
      }
    },

    async declineOrder (order) {
      const mutation = gqlOrder.DECLINE

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se declinó la orden ${order} correctamente` })
    },

    async approveOrder (order) {
      const mutation = gqlOrder.APPROVE

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se aprobó la orden ${order} correctamente` })
    },

    async disapproveOrder (order) {
      const mutation = gqlOrder.DISAPPROVE

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se desaprobó la orden ${order} correctamente` })
    },

    async payOrder (order) {
      const mutation = gqlOrder.PAY

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se pagó la orden ${order} correctamente` })
    },

    async deletePayOrder (order) {
      const mutation = gqlOrder.DELETE_PAY

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se eliminó el pagó de la orden ${order} correctamente` })
    },

    async packOrder (order) {
      const mutation = gqlOrder.PACK

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se empacó la orden ${order} correctamente` })
    },

    async unpackOrder (order) {
      const mutation = gqlOrder.UNPACK

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se desempacó la orden ${order} correctamente` })
    },

    async sendOrder (order) {
      const mutation = gqlOrder.SEND

      if (!order) return

      const response = await gql.mutate(mutation, { order, skipGuide: this.skipGuide })

      if (response) modals.showMessage({ message: `Se envió la orden ${order} correctamente` })
    },

    async backSendOrder (order) {
      const mutation = gqlOrder.BACK_SEND

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se devolvió el envío de la orden ${order} correctamente` })
    },

    async collectOrder (order) {
      const mutation = gqlOrder.COLLECT

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se cobró la orden ${order} correctamente` })
    },

    async returnCollectOrder (order) {
      const mutation = gqlOrder.RETURN_COLLECT

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se delvovió el cobró de la orden ${order} correctamente` })
    },

    async recoverOrder (order) {
      const mutation = gqlOrder.RECOVER

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se recuperó la orden ${order} correntamente` })
    }
  },

  computed: {
    action () {
      const actions = {
        expired: {
          previousAction: null,
          nextAction: this.recoverOrder,
          text: 'Recuperar',
          textRunning: 'Recuperando'
        },
        declined: {
          previousAction: null,
          nextAction: this.recoverOrder,
          text: 'Recuperar',
          textRunning: 'Recuperando'
        },
        created: {
          previousAction: this.declineOrder,
          nextAction: this.approveOrder,
          text: 'Aprobar',
          textRunning: 'Aprobando'
        },
        approved: {
          previousAction: this.disapproveOrder,
          nextAction: this.payOrder,
          text: 'Pagar',
          textRunning: 'Pagando'
        },
        paid: {
          previousAction: this.deletePayOrder,
          nextAction: this.packOrder,
          text: 'Empacar',
          textRunning: 'Empacando'
        },
        packed: {
          previousAction: this.unpackOrder,
          nextAction: this.sendOrder,
          text: 'Enviar',
          textRunning: 'Enviando',
          textConfirmation: '¿Deseas enviar la orden?'
        },
        sent: {
          previousAction: this.backSendOrder,
          nextAction: null,
          text: '',
          textRunning: ''
        }
      }

      const action = actions[this.data.status]
      if (!action) return action
      if (this.data.status === 'paid' && (this.isFraudBlocked || isBlockedByProductChange(this.data))) {
        return { ...action, nextAction: null }
      }
      if (this.data.status === 'packed' && (this.isFraudBlocked || isBlockedByAddressNovelty(this.data))) {
        return { ...action, nextAction: null }
      }
      return action
    },

    isPackActionBlocked () {
      if (this.data.status === 'packed') {
        return this.isFraudBlocked || isBlockedByAddressNovelty(this.data)
      }
      return this.isFraudBlocked || isBlockedByProductChange(this.data)
    },

    colorProfit () {
      return this.total - this.costs > 0 ? 'color-green' : 'color-red'
    },
    styleStatus () {
      if (!this.colorsStatus[this.data.status]) return ''
      return `background: ${this.colorsStatus[this.data.status].background}; color: ${this.colorsStatus[this.data.status].color}`
    },

    total () {
      return this.data.total || 0
    },

    discount () {
      return this.data.totalDiscount || 0
    },

    quantitySale () {
      return 3
    },

    costs () {
      return this.getCosts(this.data.cart)
    },

    showedMenu () {
      return this.$store.state.interface.menus[this.indexMenu]
    },

    fraudConfirmedCount () {
      return (this.data.fraudReview && this.data.fraudReview.fraudConfirmedCount) || 0
    },

    isFraudBlocked () {
      return isBlockedByFraud(this.data)
    },

    canSkipGuide () {
      return this.data.status === 'packed' && !!(this.action && this.action.nextAction)
    },

    sendActionText () {
      if (this.canSkipGuide && this.skipGuide) return 'E. Sin Guía'
      return this.action && this.action.text
    },

    sendActionTextRunning () {
      if (this.canSkipGuide && this.skipGuide) return 'Enviando sin guía'
      return this.action && this.action.textRunning
    },

    sendConfirmation () {
      if (this.data.status !== 'packed') return this.action && this.action.textConfirmation
      return this.skipGuide
        ? '¿Deseas enviar la orden sin guía?'
        : '¿Deseas enviar la orden?'
    },

    isFraudActionBlocked () {
      return this.isPackActionBlocked
    },

    fraudCountFieldOrder () {
      const fields = this.fieldsOrder
      if (!fields || !Object.keys(fields).length) return 999
      const orders = Object.values(fields).map(field => field.order || 0)
      return Math.max(...orders) + 1
    },

    fieldsOrder () {
      const fieldsArray = this.$store.state.interface.fieldsOrder
      if (fieldsArray.length === 0) return {}
      return fieldsArray.reduce((acc, field) => {
        acc[field.name] = field
        return acc
      }, {})
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/product.styl'

.order-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em
  justify-content space-between
  position relative

.order-data-container.is-verifying-fraud
  pointer-events none

.order-data-container.is-fraud-blocked
  background rgba(255, 183, 77, 0.12)

.order-fraud-count-col
  display flex
  align-items center
  justify-content center
  flex 0 0 4em
  width 4em
  min-width 4em
  text-align center

.order-verify-overlay
  position absolute
  inset 0
  z-index 20
  display flex
  align-items center
  justify-content center
  background rgba(255, 255, 255, .82)
  pointer-events all

.order-verify-overlay-box
  display flex
  align-items center
  gap .75em
  font-size 1.15rem
  font-weight 600
  color #d9534f

  .spinner
    width 1.6rem
    height 1.6rem
    border-radius 50%
    border 2px solid rgba(217, 83, 79, .2)
    border-top-color #d9534f
    animation order-verify-spin .6s linear infinite

@keyframes order-verify-spin
  100%
    transform rotate(1turn)

.order-data
  font-size 1.2rem
  align-items start
  flex-wrap wrap
  text-align left
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  display flex
  text-align left
  column-gap 1em
  padding 0 1rem

.divider-order
  background 1px solid rgba(0, 0, 0, .2)
  flex-shrink 0
  flex-basis 100%
  margin-top 1em

.order-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem

.order-actions
  display flex
  align-items center
  gap 1em

.order-actions .undo
  flex-basis 1em
  flex-shrink 0
  height 1.1em

.data-description-list-image
  height 1.2em

.aditional-icons
  display flex
  align-items center
  gap 1.5em

.aditional-checks
  margin-top 2em

.data-title-list.data-order
  display flex
  align-items center
  gap .3em

.data-description-list-image-brand
  height 1em
  display block

.buttons-copy
  display inline-flex
  gap 1em
  margin-left 1em
  margin-bottom .2em

.button-copy
  font-size 1em
  opacity .4
  cursor pointer

.button-copy:hover
  opacity 1

.data-title-list.data-order
  font-size 1em
  margin-bottom .3em

.title-order
  font-size 1.3em

.method-pay-container
  display flex
  align-items center
  gap .5em

.special
  opacity .2
  transform-origin left
  margin-top 1em

.order-index
  width 4em
  padding-top 1.1em
  color rgba(0, 0, 0, .5)
  flex-shrink 0
  flex-basis 3em
  font-size .7em
  text-align left

.order-actions img
  height 1.2em
  display block

.menu-icon-order img
  height 1em
  cursor pointer
  position relative
  top .1em

.undo img
  height 1.1em
  cursor pointer

.undo img.disabled
  opacity .2
  cursor default

.order-additional img
  height 1.2em
  opacity .5
  cursor pointer

.order-additional img:nth-child(2)
  height 1.25em

.section-container
  overflow-x scroll
  font-size 1.2rem

.order-method-pay
  display flex
  justify-content center

.order-method-pay img
  height 1.4em
  display block

.order-conveyor
  display flex
  justify-content center

.order-conveyor img
  height 1.4em
  display block

.order-number
  display flex
  align-items center
  gap .5em

.order-number.has-fraud-count
  width auto
  gap 1.5em
  padding-right 2em

.order-fraud-count
  display inline-flex
  align-items center
  justify-content center
  background #d9534f
  color #fff
  white-space nowrap
  font-size inherit
  line-height 1
  padding .1em .25em
  min-width 0
  max-width 100%
  box-sizing border-box

.order-number .material-symbols-outlined
  font-size 1.4em

.list-order
  flex-basis 100%
  flex-shrink 0
  width 100%

.order-name
  display flex
  align-items center
  gap .6rem

.order-name img
  height 1.4rem
  display block

@media (pointer: fine)
  .order-data
    flex-basis calc(100% - 16rem - 5rem)
    column-gap 0
    row-gap 1em

  .divider-order
    display none

  .menu-icon-order
    flex-basis 2em

  .order-number
    width 8em
  .order-number.has-fraud-count
    width auto
    min-width 6em
    gap 1.5em
  .order-status
    width 6em
  .order-date
    width 10em
  .order-remit
    width 4em
    display flex
    justify-content center
  .order-method-pay
    width 5em
  .order-total
    width 8em
  .order-percent-profit
    width 4em
  .order-reconcile
    width 4em
  .order-fraud-count-col
    width 4em
  .order-phone
    width 8em
  .order-name
    width 8em
  .order-location
    width 8em
  .order-department
    width 8em
  .order-conveyor
    width 5em
  .order-actions
    width 16rem

  .order-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Order.vue